import React, { createContext, useCallback, useContext, useMemo } from 'react';
import { noop } from 'react-use/lib/misc/util';
import { Permissions, useAuth } from '@kp/react-sdk';
import { useMutation } from '@tanstack/react-query';
import { getApplications, Status } from '../api/application';

export interface Badges {
  hasUpdatedApplications: boolean;
}

interface BadgeContextValue {
  refreshApplications: () => void;
  badges: Badges;
}

const BadgeContext = createContext<BadgeContextValue>({
  badges: {
    hasUpdatedApplications: false,
  },
  refreshApplications: noop,
});

export const useBadge = (): BadgeContextValue => useContext(BadgeContext);

type BadgeProviderProps = {
  children: React.ReactNode;
};
export const BadgeProvider: React.FC<BadgeProviderProps> = ({ children }) => {
  const { hasPermission } = useAuth();
  const { mutate: fetchApplications, data: response } = useMutation({
    mutationFn: getApplications,
  });

  // TODO: remove MO-229
  const refreshApplications = useCallback(
    () =>
      hasPermission(Permissions.ApplicationsRead)
        ? fetchApplications({ status: Status.updated })
        : Promise.resolve(),
    [fetchApplications, hasPermission],
  );

  // TODO: remove MO-229
  const value = useMemo(
    () => ({
      badges: {
        hasUpdatedApplications: !!response?.data?.length,
      },
      refreshApplications,
    }),
    [response, refreshApplications],
  );

  return (
    <BadgeContext.Provider value={value}>{children}</BadgeContext.Provider>
  );
};
